module.exports = __webpack_public_path__ + "img/button_icon_empresa.552901c.svg";